var _path, _path2, _path3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
import * as React from "react";
function SvgMetaWalletCard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 421,
    height: 409,
    viewBox: "0 0 421 409",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M149.841 282.712C158.782 299.307 169.719 309.927 179.177 314.846C191.572 321.285 204.26 320.11 214.834 314.548C228.478 307.372 239.312 297.77 247.281 255.253C253.652 221.181 258.265 175.647 262.188 146.542L268.827 97.2444C273.447 63.0094 279.396 24.5195 293.203 -6.69786C304.454 -32.1767 320.896 -51.6986 342.045 -62.8222C377.529 -81.486 421.292 -80.8137 465.815 -59.7953C514.563 -36.7678 554.048 3.76376 580.606 53.0565C596.395 82.3614 601.556 107.282 599.774 130.049C598.064 152.063 586.303 179.343 551.616 197.587L526.345 150.683C556.046 135.061 550.247 106.675 535.144 78.6441C513.623 38.7003 479.354 -0.180193 439.435 -19.8386C411.11 -33.7817 382.689 -36.4521 359.553 -24.2833C334.536 -11.1253 323.538 16.387 317.186 58.4819C313.798 80.847 311.987 106.9 310.015 136.246L307.834 168.544C303.467 233.468 301.677 248.657 296.251 275.057C286.688 321.294 270.312 345.544 240.114 361.427C204.293 380.268 174.136 378.265 148.792 364.655C128.105 353.604 110.39 334.121 96.6092 308.543L149.841 282.712Z",
    fill: "#0081FB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M66.5494 154.474C72.6542 108.666 94.767 67.2549 134.474 46.3701C157.468 34.276 183.616 28.3723 216.901 33.3083C253.323 38.6996 298.108 55.554 360.804 89.212L383.299 101.295C437.57 130.432 467.107 144.554 482.991 150.201C503.397 157.435 514.659 156.867 526.369 150.708C556.069 135.086 550.27 106.7 535.168 78.6692L580.612 53.0909C596.401 82.3958 601.562 107.316 599.779 130.083C598.069 152.097 586.308 179.377 551.622 197.621C530.065 208.959 508.691 214.805 477.941 208.024C454.31 202.834 422.188 188.436 395.77 174.185L317.241 131.89C277.836 110.652 244.712 96.8018 227.18 91.8585C208.332 86.5442 184.623 80.6184 159.074 94.0563C138.404 104.928 127.868 127.169 123.912 154.82L66.5494 154.474Z",
    fill: "url(#paint0_linear_9251_7295)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M159.051 94.0312C138.381 104.903 127.844 127.144 123.889 154.795C118.275 193.865 128.148 242.449 149.841 282.712C158.782 299.307 169.719 309.927 179.177 314.846L148.783 364.68C128.105 353.604 110.39 334.121 96.6092 308.543C71.5612 262.054 59.6608 206.114 66.5347 154.465C72.6395 108.657 94.7522 67.2457 134.46 46.361L159.051 94.0312Z",
    fill: "url(#paint1_linear_9251_7295)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_9251_7295",
    x1: 173.675,
    y1: 201.455,
    x2: 515.4,
    y2: 41.3053,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0064E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#0064E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#0073EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0082FB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_9251_7295",
    x1: 177.916,
    y1: 293.243,
    x2: 119.556,
    y2: 182.284,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0082FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0064E0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMetaWalletCard);
export default __webpack_public_path__ + "static/media/meta-wallet-card.1c1fb7b2651fd018e81e7a87131166c8.svg";
export { ForwardRef as ReactComponent };